import { inject, Injectable } from '@angular/core';
import { IdleCallbackService } from '@core/services/idle-callback.service';
import { ReplaySubject } from 'rxjs';
import { filter, map, shareReplay, switchMap } from 'rxjs/operators';
import { ScriptLoaderService } from './script-loader.service';
import { WINDOW } from './window.service';

@Injectable({
    providedIn: 'root',
})
export class TawkToService {
    private scriptUrl =
        'https://embed.tawk.to/677d0d16af5bfec1dbe7cd56/1ih07m84i';

    private scriptLoaderService = inject(ScriptLoaderService);
    private window: any = inject(WINDOW);
    private idleCallbackService = inject(IdleCallbackService);

    private fullyLoaded = new ReplaySubject<boolean>(1);

    private tawkToApi = this.idleCallbackService.firstIdleCallback().pipe(
        switchMap(() => this.scriptLoaderService.load(this.scriptUrl)),
        filter(data => !!data),
        switchMap(() => this.fullyLoaded.pipe(filter(loaded => loaded))),
        map(() => this.window.Tawk_API),
        shareReplay(1)
    );

    constructor() {
        if (this.window.Tawk_API) {
            this.window.Tawk_API.onBeforeLoad = () =>
                this.fullyLoaded.next(true);
        }
    }

    initialize(): void {
        this.tawkToApi.subscribe({
            next: () => {
                console.log('Tawk.to script loaded successfully');
            },
            error: error => {
                console.error('Failed to load Tawk.to script', error);
            },
        });
    }

    toggle(): void {
        this.tawkToApi.subscribe(tawkApi => tawkApi.toggle());
    }

    hideWidget(): void {
        this.tawkToApi.subscribe(tawkApi => tawkApi.hideWidget());
    }

    shutdown(): void {
        this.tawkToApi.subscribe(tawkApi => tawkApi.shutdown());
    }

    open(): void {
        this.tawkToApi.subscribe(tawkApi => tawkApi.maximize());
    }
}
